import {AbstractSelectEditControlComponent} from "./abstract-select-edit-control.component";
import {Directive, Injector, Input, model, ViewChild} from "@angular/core";
import {SingleSelectControlComponent} from "../../../select/single-select-control.component";
import {SearchModel} from "@fedeltapointofsale/data-client";

/**
 * Abstract class that implements methods for the single select edit inputs
 */
@Directive()
export class AbstractSingleSelectEditControlComponent <T extends SearchModel<any>> extends AbstractSelectEditControlComponent<T> {
    @Input() objectValue: any;
    @Input() clearSelectionOptionLabel: string;
    @Input() allowClearSelectionOption: boolean = true;
    @Input() allowDirectInput: boolean = false;
    @Input() isNumeric: boolean = false;

    private _selectControlComponent: SingleSelectControlComponent;
    private loadOnInit: boolean = false;

    constructor(model: T, injector: Injector, valueField?: string, labelField?: string, protected overrideOpenView: boolean = false) {
        super(model, injector, valueField, labelField);
    }

    @ViewChild(SingleSelectControlComponent)
    set selectControlComponent(value: SingleSelectControlComponent) {
        this._selectControlComponent = value;
        if (this.loadOnInit) {
            this._selectControlComponent.loadDataFromSearchModel();
        }
    }

    get selectControlComponent(): SingleSelectControlComponent {
        return this._selectControlComponent;
    }

    click() {
        this._selectControlComponent.click();
    }

    focus() {
        this._selectControlComponent.focus();
    }

    loadDataFromSearchModel(): void {
        if (this._selectControlComponent) {
            this._selectControlComponent.loadDataFromSearchModel();
        } else {
            this.loadOnInit = true;
        }
    }
}
